
const digest = '7c127c3594345e72978a9324ca17e76ffcfb00a23dfd1ae0c73cf7adc4d947da';
const classes = {"buttons":"_buttons_1ux9n_1"};
const css = `._buttons_1ux9n_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  